import { useCallback } from "react";

import type createScoringBoardTrackingService from "app/pages/sales-intelligence/modules/lead-scoring-agent/services/tracking/scoring-board-factory";

type ScoringBoardTracking = ReturnType<typeof createScoringBoardTrackingService>;

export const useScoringRuleDeleteModalHandlers = <TDeleteState>(
    deleteState: TDeleteState | null,
    setDeleteState: (state: null) => void,
    scoringBoardTracking: ScoringBoardTracking,
) => {
    const resetDeleteState = useCallback(() => setDeleteState(null), [setDeleteState]);

    const handleDeleteCancel = useCallback(() => {
        scoringBoardTracking.trackCancelDeleteRule();
        resetDeleteState();
    }, [resetDeleteState, scoringBoardTracking]);

    const confirmDeleteIfReady = useCallback((): TDeleteState | null => {
        if (!deleteState) {
            return null;
        }

        scoringBoardTracking.trackConfirmDeleteRule();
        return deleteState;
    }, [deleteState, scoringBoardTracking]);

    return { resetDeleteState, handleDeleteCancel, confirmDeleteIfReady };
};
